import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { PagerComponent } from '@src/suite/common/components/pager/pager';
import { selectIsTileLayout } from '@src/suite/common/store/navigation/selectors/viewstate.selectors';
import { PlaybookActions } from '@src/suite/common/store/playbook/playbook.actions';
import { selectTotalGroupCount } from '@src/suite/discover/store/selectors/discover.selectors';

@Component({
    selector: 'st-discover-right-slot',
    imports: [MatButtonToggleModule, MatListModule, MatMenuModule, MatTooltipModule, PagerComponent],
    templateUrl: './discover-right-slot.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-discover-right-slot',
    },
})
export class DiscoverRightSlotComponent {
    store = inject(Store);

    isTileLayout = this.store.selectSignal(selectIsTileLayout);
    totalGroupCount = this.store.selectSignal(selectTotalGroupCount);

    onStartIndexChange(startIndex: number) {
        this.store.dispatch(PlaybookActions.setStartIndex({ startIndex }));
    }
}
